import React from 'react';
import './styles.scss';
import config from 'config';
import { ITravelAgencyListItem } from './interface';

function TravelAgencyListItem({ travelAgency }: ITravelAgencyListItem) {
    return (
        <div className='travel-agency-list-item'>
            <img
                src={`${config.API_URL}/travel/images/${travelAgency.Id}`}
                alt='Item Img'
            />
            <p className='travel-agency-list-item__title'>
                {travelAgency.Travelagencylanguages[0].Name}
            </p>
            <p className='travel-agency-list-item__description'>
                {travelAgency.Contact.replace('.', ' ')}
            </p>
            <p className='travel-agency-list-item__description'>
                {travelAgency.Travelagencylanguages[0].Location}
            </p>
        </div>
    );
}

export default TravelAgencyListItem;
